// Reglas locales de los smart combos. Con ?todas_las_vigencias=1 el servidor no filtra por día ni por
// fecha_inicio: se filtra aquí, con la fecha LOCAL del equipo (no toISOString, que da UTC).

export function fechaLocalISO(ahora = new Date()) {
  const p = (n) => String(n).padStart(2, '0');
  return `${ahora.getFullYear()}-${p(ahora.getMonth() + 1)}-${p(ahora.getDate())}`;
}

export function promoVigenteHoy(promo, ahora = new Date()) {
  const hoy = fechaLocalISO(ahora);
  if (promo.fecha_inicio && promo.fecha_inicio > hoy) return false;
  if (promo.fecha_fin && promo.fecha_fin < hoy) return false;
  const diaIso = ahora.getDay() || 7; // 1 = lunes … 7 = domingo, como promotions.dia_semana
  return !promo.dia_semana || Number(promo.dia_semana) === diaIso;
}

// Tipos que el modal no sabe armar todavía (Etapa 8): sin conexión no se ofrecen.
// Antes: «tipo_descuento solo admite 'percentage' (enum de promotion_actions); unidad_objetivo 0 = no se usa.»
// tipo_descuento solo admite 'percentage' (enum de promotion_actions).
// unidad_objetivo (ajuste_combos_offline.md, opción B): la columna vale 1 por defecto y la pantalla de promociones
// siempre manda ≥ 1; ningún motor lo usa (PromotionEngine no lo lee). Solo un valor ≥ 2 indicaría «descuento a la
// N-ésima unidad», que el modal no sabe armar.
// Etapa 8 (ítem 19, etapa_8_promos.md 5.2): el 2x1 «mismo producto» (una condición «repetido» y una acción
// «producto», como lo guarda el formulario) ya se arma sin conexión. Siguen ocultas (D3/D4): «repetido» con otra
// acción, «producto» con otra condición y cualquier mezcla de varias reglas. Antes:
// export function promoSoportadaOffline(promo) {
//   const condiciones = promo.conditions || [];
//   const acciones = promo.actions || [];
//   if (condiciones.some((c) => c.tipo === 'repetido')) return false;
//   if (acciones.some((a) => a.aplica_a === 'producto')) return false;
//   // Antes (ocultaba TODOS los combos sin conexión, porque unidad_objetivo nunca es 0):
//   // if (acciones.some((a) => Number(a.unidad_objetivo) > 0)) return false;
//   if (acciones.some((a) => Number(a.unidad_objetivo) > 1)) return false;
//   if (acciones.some((a) => a.tipo_descuento && a.tipo_descuento !== 'percentage')) return false;
//   return true;
// }
export function promoSoportadaOffline(promo) {
  const condiciones = promo.conditions || [];
  const acciones = promo.actions || [];
  // (unidad_objetivo > 1: antes > 0 ocultaba TODOS los combos sin conexión, porque unidad_objetivo nunca es 0)
  if (acciones.some((a) => Number(a.unidad_objetivo) > 1)) return false;
  if (acciones.some((a) => a.tipo_descuento && a.tipo_descuento !== 'percentage')) return false;
  if (esPromoMismoProducto(promo)) return true;
  if (condiciones.some((c) => c.tipo === 'repetido')) return false;
  if (acciones.some((a) => a.aplica_a === 'producto')) return false;
  return true;
}

// Etapa 8 (5.1): 2x1 «mismo producto»: exactamente una condición «repetido» («Comprar el mismo producto N veces»)
// y una acción «producto» («Descuento a la misma unidad»). Es lo único que crea el formulario con esos tipos.
export function esPromoMismoProducto(promo) {
  const condiciones = (promo && promo.conditions) || [];
  const acciones = (promo && promo.actions) || [];
  return condiciones.length === 1 && condiciones[0].tipo === 'repetido'
    && acciones.length === 1 && acciones[0].aplica_a === 'producto';
}

const redondear2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100; // = posCarrito.redondear2

// Etapa 8 (5.1): las N líneas de un 2x1 «mismo producto», cada una de cantidad 1 (como los combos, que no se fusionan).
// N = cantidad_minima de la condición. Unidades con descuento = min(floor(N / cantidad_minima), max_aplicaciones_carrito)
// = 1 (la regla BOGO del motor del backend), y son las ÚLTIMAS. Descuento de cada una = round(precio × % / 100, 2),
// igual que descuentoLineaCombo (lo que guarda el backend: no recalcula). Función pura.
// Devuelve { lineas: [{ descuento_neto }], unidades, afectadas, normal, descuento, total, etiqueta }.
export function armarLineasMismoProducto(promo, precioUnitario) {
  const condicion = promo.conditions[0];
  const accion = promo.actions[0];
  const precio = Number(precioUnitario) || 0;
  const minimo = Math.max(1, Number(condicion.cantidad_minima) || 1);
  const unidades = minimo;
  const tope = accion.max_aplicaciones_carrito ? Number(accion.max_aplicaciones_carrito) : Infinity;
  const afectadas = Math.min(Math.floor(unidades / minimo), tope);
  const porcentaje = Number(accion.valor_descuento) || 0;
  const descuentoUnidad = redondear2(precio * porcentaje / 100);
  const lineas = [];
  for (let i = 0; i < unidades; i += 1) {
    lineas.push({ descuento_neto: i >= unidades - afectadas ? descuentoUnidad : 0 });
  }
  const normal = redondear2(precio * unidades);
  const descuento = redondear2(lineas.reduce((s, l) => s + l.descuento_neto, 0));
  // «2x1» con 100 % (N iguales, paga N − 1); si no, «N × con X % en la última»
  const etiqueta = porcentaje >= 100 && afectadas === 1 ? `${unidades}x${unidades - 1}` : `${porcentaje}% en ${afectadas === 1 ? 'la última' : afectadas + ' unidades'}`;
  return { lineas, unidades, afectadas, normal, descuento, total: redondear2(normal - descuento), etiqueta };
}

export function promoDelCanal(promo, canalId) {
  const canales = promo.canales_id;
  return !canales || canales.length === 0 || canales.map(Number).includes(Number(canalId));
}
